import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
  standalone: false,
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string): string {
    let defaultIndex = 50;
    let regex = '\n';
    let index = value.indexOf(regex);
    return (
      value.substring(
        0,
        index != -1 && index < defaultIndex ? index : defaultIndex,
      ) + '...'
    );
  }
}
